// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3e2bw","detailsBorder":"styles_detailsBorder__1d8rA"};